document.addEventListener("DOMContentLoaded", (event) => {
    function checkAllVideos() {
    const videos = document.querySelectorAll("video");

    if (!videos.length) {
        console.log("No videos found");
        return;
    }

    videos.forEach((video, index) => {
        const initialTime = video.currentTime;

        setTimeout(() => {
            const isPlaying =
                !video.paused &&
                !video.ended &&
                video.currentTime > initialTime;

            console.log(`Video #${index + 1}:`, {
                paused: video.paused,
                currentTime: video.currentTime,
                readyState: video.readyState,
                status: isPlaying ? "✅ Playing" : "❌ Not playing"
            });
            }, 1200);
        });
    }

    checkAllVideos();
});